import axios from '../helpers/axios';
import * as errors from '../errors';
import type { AppThunk, Notify } from '../typings/redux';
import { getTranslationKey } from '../modules/utils';

export const createAppointment =
  (appointment: Record<string, any>, notify: Notify): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      const res = await axios.post('/api/appointment', appointment);
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('timeslotPopUp.appointmentCreated'),
        status: 'success',
        position: 'bottom-left',
        dismissible: true,
        dismissAfter: 3000
      });
      dispatch({ type: 'ADD_APPOINTMENT', payload: res.data });
      dispatch({ type: 'TOGGLE_TIMESLOT_POPUP' });
    } catch (e) {
      errors.handleErrorWithRedirectIfNotAuth(e, notify);
    }
  };

export const editAppointment =
  (appointment: Record<string, any>, notify: Notify): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      const res = await axios.put('/api/appointment', { appointment });
      dispatch({ type: 'EDIT_APPOINTMENT', payload: res.data });
      dispatch({ type: 'TOGGLE_TIMESLOT_POPUP' });
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('timeslotPopUp.appointmentEdited'),
        status: 'success',
        position: 'bottom-left',
        dismissible: true,
        dismissAfter: 3000
      });
    } catch (e) {
      errors.handleErrorWithRedirectIfNotAuth(e, notify);
    }
  };

export const getAppointments =
  (range: Record<string, any>, notify?: Notify): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      const res = await axios.get('/api/appointments', { params: range });
      dispatch({ type: 'SET_ALL_APPOINTMENTS', payload: res.data });
    } catch (e) {
      errors.handleErrorWithRedirectIfNotAuth(e, notify);
    }
  };

export const deleteAppointment =
  (appointment: Record<string, any>, notify: Notify): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      await axios.delete('/api/appointment/', { data: { appointment } });
      dispatch({ type: 'REMOVE_APPOINTMENT', payload: appointment._id });
      dispatch({ type: 'TOGGLE_TIMESLOT_POPUP' });
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('timeslotPopUp.appointmentDeleted'),
        status: 'info',
        position: 'bottom-left',
        dismissible: true,
        dismissAfter: 3000
      });
    } catch (e) {
      errors.handleErrorWithRedirectIfNotAuth(e);
    }
  };

export const toggleTimeslotPopUp = (): AppThunk => (dispatch) => {
  try {
    dispatch({ type: 'TOGGLE_TIMESLOT_POPUP' });
  } catch (e) {
    errors.handleErrorWithRedirectIfNotAuth(e);
  }
};
